<div
  class="flex min-w-0 w-full flex-wrap items-baseline justify-start gap-x-2 gap-y-1"
>
  <span class="min-w-0 max-w-full shrink-0 truncate font-semibold">
    {{ columnName }}
  </span>

  <div class="flex flex-none items-baseline gap-2">
    @if (hasFilters) {
      <app-filterable-column-header
        [columnName]="columnName"
        [columnKey]="columnKey"
        [options]="options"
        [selectedValues]="selectedValues"
        (filterChanged)="onFilterChanged($event)"
      ></app-filterable-column-header>
    }

    <button
      type="button"
      class="sort-arrow inline-flex items-center justify-center p-1 -mt-1 leading-none transition-all duration-150 rounded hover:bg-surface-switch-200 hover:text-primary-500 cursor-pointer"
      [ngClass]="{
        'text-primary-600 font-semibold bg-surface-switch-200': isActiveSort,
      }"
      (click)="toggleSort(); $event.stopPropagation()"
    >
      <i
        class="pi"
        [ngClass]="{
          'pi-sort-alpha-up': sortDirection === 'asc',
          'pi-sort-alpha-down': sortDirection === 'desc',
          'pi-sort-alt': !isActiveSort,
        }"
      ></i>
    </button>
  </div>
</div>
